__turbopack_context__.v({
  "capabilities": "Capabilities-module-scss-module__4jR-rG__capabilities",
  "cta": "Capabilities-module-scss-module__4jR-rG__cta",
  "ctaWrapper": "Capabilities-module-scss-module__4jR-rG__ctaWrapper",
  "description": "Capabilities-module-scss-module__4jR-rG__description",
  "inner": "Capabilities-module-scss-module__4jR-rG__inner",
  "rollHidden": "Capabilities-module-scss-module__4jR-rG__rollHidden",
  "rollVisible": "Capabilities-module-scss-module__4jR-rG__rollVisible",
  "rowContent": "Capabilities-module-scss-module__4jR-rG__rowContent",
  "sectionHeader": "Capabilities-module-scss-module__4jR-rG__sectionHeader",
  "serviceItem": "Capabilities-module-scss-module__4jR-rG__serviceItem",
  "serviceList": "Capabilities-module-scss-module__4jR-rG__serviceList",
  "serviceRow": "Capabilities-module-scss-module__4jR-rG__serviceRow",
  "stack-module-0": "Capabilities-module-scss-module__4jR-rG__stack-module-0",
  "stack-module-1": "Capabilities-module-scss-module__4jR-rG__stack-module-1",
  "stack-module-10": "Capabilities-module-scss-module__4jR-rG__stack-module-10",
  "stack-module-11": "Capabilities-module-scss-module__4jR-rG__stack-module-11",
  "stack-module-12": "Capabilities-module-scss-module__4jR-rG__stack-module-12",
  "stack-module-13": "Capabilities-module-scss-module__4jR-rG__stack-module-13",
  "stack-module-14": "Capabilities-module-scss-module__4jR-rG__stack-module-14",
  "stack-module-15": "Capabilities-module-scss-module__4jR-rG__stack-module-15",
  "stack-module-16": "Capabilities-module-scss-module__4jR-rG__stack-module-16",
  "stack-module-17": "Capabilities-module-scss-module__4jR-rG__stack-module-17",
  "stack-module-18": "Capabilities-module-scss-module__4jR-rG__stack-module-18",
  "stack-module-19": "Capabilities-module-scss-module__4jR-rG__stack-module-19",
  "stack-module-2": "Capabilities-module-scss-module__4jR-rG__stack-module-2",
  "stack-module-20": "Capabilities-module-scss-module__4jR-rG__stack-module-20",
  "stack-module-3": "Capabilities-module-scss-module__4jR-rG__stack-module-3",
  "stack-module-4": "Capabilities-module-scss-module__4jR-rG__stack-module-4",
  "stack-module-5": "Capabilities-module-scss-module__4jR-rG__stack-module-5",
  "stack-module-6": "Capabilities-module-scss-module__4jR-rG__stack-module-6",
  "stack-module-7": "Capabilities-module-scss-module__4jR-rG__stack-module-7",
  "stack-module-8": "Capabilities-module-scss-module__4jR-rG__stack-module-8",
  "stack-module-9": "Capabilities-module-scss-module__4jR-rG__stack-module-9",
  "titleWrap": "Capabilities-module-scss-module__4jR-rG__titleWrap",
  "z-base": "Capabilities-module-scss-module__4jR-rG__z-base",
  "z-content": "Capabilities-module-scss-module__4jR-rG__z-content",
  "z-footer": "Capabilities-module-scss-module__4jR-rG__z-footer",
  "z-header": "Capabilities-module-scss-module__4jR-rG__z-header",
  "z-hero": "Capabilities-module-scss-module__4jR-rG__z-hero",
  "z-logo": "Capabilities-module-scss-module__4jR-rG__z-logo",
  "z-logo-effect": "Capabilities-module-scss-module__4jR-rG__z-logo-effect",
  "z-navigation": "Capabilities-module-scss-module__4jR-rG__z-navigation",
  "z-sub": "Capabilities-module-scss-module__4jR-rG__z-sub",
});
